import React from 'react';
import { HealthServiceTemplate } from '../../Templates';
import { apiGetHealthService, apiGetCarteBlancheLink } from '../../Api/HealthService/HealthService';
import { HealthServiceEnum } from '../../Config/enums';

class HealthService extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasHealthService: false,
      content: HealthServiceEnum.NONE,
      url: '',
      fetchDone: false
    };
  }

  onGoToHealthServiceWebsite = () => {
    window.open(this.state.url, '_blank', 'noopener,noreferrer');
  };

  getHealthService = async () => {
    const res = await apiGetHealthService();
    if (res.status === 200) {
      switch (res.typeService) {
        case HealthServiceEnum.SANTECLAIR:
        case HealthServiceEnum.ITELIS:
        case HealthServiceEnum.KALIXIA:
        case HealthServiceEnum.KALIVIA:
          this.setState({
            hasHealthService: true,
            content: res.typeService,
            url: res.linkService,
            fetchDone: true
          });
          break;
        case HealthServiceEnum.CARTEBLANCHE:
          const resCarteBlanche = await apiGetCarteBlancheLink();
          this.setState({
            hasHealthService: true,
            content: res.typeService,
            url: resCarteBlanche.data,
            fetchDone: true
          });
          break;
        default:
          this.setState({
            hasHealthService: false,
            fetchDone: true
          });
          break;
      }
    } else {
      alert(
        "Votre service de santé n'est pas accessible actuellement. Veuillez ré-essayer plus tard."
      );
      this.setState({
        hasHealthService: false,
        fetchDone: true
      });
    }
  };

  componentDidMount = async () => {
    this.getHealthService();
  };

  render() {
    return (
      <HealthServiceTemplate
        state={this.state}
        onGoToHealthServiceWebsite={this.onGoToHealthServiceWebsite}
      />
    );
  }
}

export default HealthService;
